import { post } from "../../utils/Backend";
import { useLongfansMock } from "../../global/GlobalMock";
import {
  mockGetLatestViewpoints,
  mockGetOldViewpoints,
  mockGetPinnedViewpoints,
  mockListViewpointCategories,
  mockToggleViewpointCollect,
  mockToggleViewpointLike,
} from "./ViewpointFeedMock";
import type {
  ViewpointFeedCategoryListResult,
  ViewpointFeedEngagementParam,
  ViewpointFeedEngagementState,
  ViewpointFeedSliceQuery,
  ViewpointFeedSliceResult,
  ViewpointPinnedListQuery,
  ViewpointPinnedListResult,
} from "./ViewpointFeedTypes";

/** 本地调试 Mock 时改为 useLongfansMock；关闭 Mock 时 `&& false` */
const mockViewpointFeed = useLongfansMock && false;

const URL_OLD =
  process.env.REACT_APP_VIEWPOINT_FEED_OLD_URL?.trim() ||
  "/lark/app/viewpointFeed/getOldViewpoints";
const URL_LATEST =
  process.env.REACT_APP_VIEWPOINT_FEED_LATEST_URL?.trim() ||
  "/lark/app/viewpointFeed/getLatestViewpoints";
const URL_PINNED =
  process.env.REACT_APP_VIEWPOINT_FEED_PINNED_URL?.trim() ||
  "/lark/app/viewpointFeed/getPinnedViewpoints";
const URL_TOGGLE_LIKE =
  process.env.REACT_APP_VIEWPOINT_FEED_TOGGLE_LIKE_URL?.trim() ||
  "/lark/app/viewpointFeed/toggleViewpointLike";
const URL_TOGGLE_COLLECT =
  process.env.REACT_APP_VIEWPOINT_FEED_TOGGLE_COLLECT_URL?.trim() ||
  "/lark/app/viewpointFeed/toggleViewpointCollect";
const URL_LIST_CATEGORIES =
  process.env.REACT_APP_VIEWPOINT_FEED_LIST_CATEGORIES_URL?.trim() ||
  "/lark/app/viewpointFeed/listViewpointCategories";

export const ViewpointFeedApi = {
  async getOldViewpoints(
    query: ViewpointFeedSliceQuery
  ): Promise<ViewpointFeedSliceResult | string> {
    if (mockViewpointFeed) {
      return mockGetOldViewpoints(query);
    }
    return post<ViewpointFeedSliceQuery, ViewpointFeedSliceResult>(URL_OLD, query, {
      silent: true,
    });
  },

  async getLatestViewpoints(
    query: ViewpointFeedSliceQuery
  ): Promise<ViewpointFeedSliceResult | string> {
    if (mockViewpointFeed) {
      return mockGetLatestViewpoints(query);
    }
    return post<ViewpointFeedSliceQuery, ViewpointFeedSliceResult>(URL_LATEST, query, {
      silent: true,
    });
  },

  async getPinnedViewpoints(
    query: ViewpointPinnedListQuery
  ): Promise<ViewpointPinnedListResult | string> {
    if (mockViewpointFeed) {
      return mockGetPinnedViewpoints(query);
    }
    return post<ViewpointPinnedListQuery, ViewpointPinnedListResult>(URL_PINNED, query, {
      silent: true,
    });
  },

  async toggleLike(
    param: ViewpointFeedEngagementParam
  ): Promise<ViewpointFeedEngagementState | string> {
    if (mockViewpointFeed) {
      return mockToggleViewpointLike(param);
    }
    return post<ViewpointFeedEngagementParam, ViewpointFeedEngagementState>(
      URL_TOGGLE_LIKE,
      param,
      { silent: true }
    );
  },

  async toggleCollect(
    param: ViewpointFeedEngagementParam
  ): Promise<ViewpointFeedEngagementState | string> {
    if (mockViewpointFeed) {
      return mockToggleViewpointCollect(param);
    }
    return post<ViewpointFeedEngagementParam, ViewpointFeedEngagementState>(
      URL_TOGGLE_COLLECT,
      param,
      { silent: true }
    );
  },

  async listViewpointCategories(query: {
    spaceId: string;
    spaceProductId: string;
  }): Promise<ViewpointFeedCategoryListResult | string> {
    if (mockViewpointFeed) {
      return mockListViewpointCategories(query);
    }
    return post<
      { spaceId: string; spaceProductId: string },
      ViewpointFeedCategoryListResult
    >(URL_LIST_CATEGORIES, query, {
      silent: true,
    });
  },
};
